import type { ServerErrorResponse } from "@/shared/libs/http/axios/interface";
import { singleton } from "tsyringe";

export interface CommonAccountsBehaviorStructure {
    checkAccessTokenError: (error: ServerErrorResponse) => boolean;
}

@singleton()
export class CommonAccountsBehavior implements CommonAccountsBehaviorStructure {
    public checkAccessTokenError = (error: ServerErrorResponse) => {
        // TODO: 생각해봐야 할 것은 위 메시지가 변동이 있을 때의 상황이다..
        if (
            error.errorMessage &&
            ["jwt malformed", "jwt expired", "Access Token Error"].includes(error.errorMessage)
        ) {
            return true;
        }

        if (
            ["COMMON-ACCOUNTS-004", "COMMON-ACCOUNTS-005", "COMMON-ACCOUNTS-999"].includes(
                error.errorCode,
            )
        ) {
            return true;
        }

        return false;
    };
}
